import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { self, selfData } from '../../../interfaces/patient-services/self';
import { selfApi } from '../api/self.api';

@Injectable() 
export class selfService extends selfData{
 
  constructor(private api: selfApi) {
    super();
  } 
  
  getall(url: string): Observable<self[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<self>{
      return this.api.getby_id(url);
  }

  create(url: string, data:self): Observable<self[]> {
    return this.api.add(url,data);
  }

  getData(url: string, data:any): Observable<any[]> {
    return this.api.getData(url,data);
  }

  update(url: string, data:self): Observable<self> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
